import { Icon, SvgSmileAlt } from '@loomhq/lens';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateTextOverlayShow } from 'actions/textOverlay';
import { ROLLOUT_TEXT_TO_SPEECH_VIEWING } from 'constants/featureFlag';

import { useFeatureFlagValue } from 'hooks/featureFlag';

import ControlBarButton from '../control-bar-button';

import './styles.less';

const TEXT_SPEECH_LOCAL_STORAGE_KEY = 'text2s-show';

const TextToSpeechButtonWrapper = props => {
  const featureEnabled = useFeatureFlagValue(ROLLOUT_TEXT_TO_SPEECH_VIEWING);

  if (!featureEnabled) {
    return null;
  }

  return <TextToSpeechButton {...props} />;
};

const TextToSpeechButton = props => {
  const dispatch = useDispatch();

  const text2SpeechVisible = useSelector(state => state.textOverlay.show);

  useEffect(() => {
    try {
      let show = JSON.parse(
        localStorage.getItem(TEXT_SPEECH_LOCAL_STORAGE_KEY)
      );

      if (show === null) {
        show = true;
        localStorage.setItem(TEXT_SPEECH_LOCAL_STORAGE_KEY, 'true');
      }

      dispatch(updateTextOverlayShow(show));
    } catch (error) {
      console.error('Error loading text-speech state from localstorage');
    }
  }, [dispatch]);

  const toggleText2Speech = () => {
    localStorage.setItem(
      TEXT_SPEECH_LOCAL_STORAGE_KEY,
      String(!text2SpeechVisible)
    );

    dispatch(updateTextOverlayShow(Boolean(!text2SpeechVisible)));
  };

  return (
    <ControlBarButton
      className={classNames('video-player-pip-button', {
        'crowded-embed': props.crowded,
      })}
      hoverTagText="Toggle Text2Speech"
      seeking={props.seeking}
      onClick={toggleText2Speech}
      inTrimMode={props.inTrimMode}
    >
      <Icon
        className="control-bar-button-icon"
        color={props.inTrimMode ? 'disabledContent' : 'white'}
        icon={<SvgSmileAlt />}
      />
    </ControlBarButton>
  );
};

export default TextToSpeechButtonWrapper;
